import TemplateDashboard from "../../../components/TemplateDashboard";
import MscontaContent from './components/MscontaContent';

const MSconta = () => {

    return (
        <>

            <TemplateDashboard>
                <MscontaContent />
            </TemplateDashboard>

        </>
    )
};

export default MSconta;